// Price catalog + calculation rules for the Kalkulator Estimasi (Mekanisme 1: per-item).
// Ported 1:1 from the standalone calculator (Adari Interior Price List 2026) so every
// number here matches the source exactly — only the delivery (React state instead of
// vanilla DOM) changed. mn/mx = harga rendah/tinggi (Rp) per satuan for that kelas.
import { rupiah } from "@/lib/format";

export const CAT = {
  "": { label: "— Pilih dari katalog —" },
  kitchen: { label: "Kabinet Kitchen Set", g: [
    { k: "ESSENTIAL", mn: 3500000, mx: 4300000, b: "std" },
    { k: "SIGNATURE", mn: 4500000, mx: 6500000, b: "dlx" },
    { k: "Luxury", mn: 7000000, mx: 15000000, b: "lux" },
  ] },
  wardrobe: { label: "Kabinet Wardrobe", g: [
    { k: "ESSENTIAL", mn: 3500000, mx: 4300000, b: "std" },
    { k: "SIGNATURE", mn: 4500000, mx: 6500000, b: "dlx" },
    { k: "Luxury", mn: 7000000, mx: 15000000, b: "lux" },
  ] },
  showcase: { label: "Showcase", g: [
    { k: "ESSENTIAL", mn: 2700000, mx: 3100000, b: "std" },
    { k: "SIGNATURE", mn: 3200000, mx: 4300000, b: "dlx" },
    { k: "Std Duco", mn: 4000000, mx: 6000000, b: "oth" },
    { k: "Luxury", mn: 4500000, mx: 8000000, b: "lux" },
  ] },
  wall: { label: "Wall Treatment", g: [
    { k: "ESSENTIAL", mn: 1500000, mx: 1800000, b: "std" },
    { k: "SIGNATURE", mn: 1900000, mx: 3500000, b: "dlx" },
    { k: "Std Duco", mn: 2700000, mx: 3500000, b: "oth" },
    { k: "Luxury", mn: 3600000, mx: 7000000, b: "lux" },
  ] },
  backdrop: { label: "Backdrop TV", g: [
    { k: "ESSENTIAL", mn: 1700000, mx: 2100000, b: "std" },
    { k: "SIGNATURE", mn: 2150000, mx: 3500000, b: "dlx" },
    { k: "Std Duco", mn: 2900000, mx: 3600000, b: "oth" },
    { k: "Luxury", mn: 3700000, mx: 7500000, b: "lux" },
  ] },
  meja: { label: "Meja Rias / Kerja / Belajar", g: [
    { k: "SIGNATURE", mn: 3200000, mx: 3200000, b: "dlx" },
    { k: "PRESTIGE", mn: 4200000, mx: 4200000, b: "oth" },
    { k: "Prem. Luxury", mn: 5500000, mx: 5500000, b: "lux" },
    { k: "Duco", mn: 3500000, mx: 3500000, b: "oth" },
  ] },
  cradenza: { label: "Cradenza", g: [
    { k: "ESSENTIAL", mn: 2700000, mx: 2700000, b: "std" },
    { k: "SIGNATURE", mn: 3200000, mx: 3200000, b: "dlx" },
    { k: "PRESTIGE", mn: 4200000, mx: 4200000, b: "oth" },
    { k: "Prem. Luxury", mn: 5500000, mx: 5500000, b: "lux" },
    { k: "Duco", mn: 3400000, mx: 3400000, b: "oth" },
  ] },
  ranjang: { label: "Ranjang / Dipan", g: [
    { k: "ESSENTIAL", mn: 2600000, mx: 2600000, b: "std" },
    { k: "SIGNATURE", mn: 3300000, mx: 3300000, b: "dlx" },
    { k: "PRESTIGE", mn: 4300000, mx: 4300000, b: "oth" },
    { k: "Prem. Luxury", mn: 5500000, mx: 5500000, b: "lux" },
    { k: "Duco", mn: 3350000, mx: 3350000, b: "oth" },
  ] },
  nakas: { label: "Nakas", g: [
    { k: "ESSENTIAL", mn: 4000000, mx: 4000000, b: "std" },
    { k: "SIGNATURE", mn: 7500000, mx: 7500000, b: "dlx" },
    { k: "PRESTIGE", mn: 13500000, mx: 13500000, b: "oth" },
    { k: "Prem. Luxury", mn: 25000000, mx: 25000000, b: "lux" },
    { k: "Duco", mn: 5000000, mx: 5000000, b: "oth" },
  ] },
  pintu: { label: "Pintu Kamuflase", g: [
    { k: "ESSENTIAL", mn: 7000000, mx: 7000000, b: "std" },
    { k: "SIGNATURE", mn: 15000000, mx: 15000000, b: "dlx" },
    { k: "PRESTIGE", mn: 25000000, mx: 25000000, b: "oth" },
    { k: "Prem. Luxury", mn: 35000000, mx: 35000000, b: "lux" },
    { k: "Duco Std", mn: 10500000, mx: 10500000, b: "oth" },
  ] },
  lantai: { label: "Lantai", g: [
    { k: "Vinyl", mn: 650000, mx: 650000, b: "std" },
    { k: "SPC Standard", mn: 750000, mx: 750000, b: "std" },
    { k: "SPC Premium", mn: 1450000, mx: 1450000, b: "dlx" },
    { k: "Parket", mn: 800000, mx: 800000, b: "dlx" },
  ] },
  plafond: { label: "Plafond", g: [
    { k: "SIGNATURE", mn: 550000, mx: 550000, b: "dlx" },
    { k: "Luxury", mn: 900000, mx: 900000, b: "lux" },
    { k: "PRESTIGE", mn: 1300000, mx: 1300000, b: "oth" },
    { k: "Custom", mn: 1700000, mx: 1700000, b: "oth" },
  ] },
  manual: { label: "Pekerjaan Lainnya (manual)" },
};

// Mekanisme 1 dipilih dari katalog untuk hampir semua pekerjaan — "Pekerjaan Lainnya
// (manual)" tetap disediakan sebagai satu baris pengecualian untuk pekerjaan yang belum ada
// di katalog, bukan jalur utama (jalur utama tetap pilih dari katalog seperti biasa).
export const CAT_GROUPS = [
  ["Kabinet", ["kitchen", "wardrobe", "showcase"]],
  ["Wall & Feature", ["wall", "backdrop"]],
  ["Furnitur", ["meja", "cradenza", "ranjang"]],
  ["Per Unit", ["nakas", "pintu"]],
  ["Lantai & Plafond", ["lantai", "plafond"]],
  ["Lainnya", ["manual"]],
];

export const SAT = ["m²", "m'", "Unit", "LS / Borongan"];
export const DEF_ROOMS = ["Master Bedroom", "Living Room", "Dapur", "Kamar Anak", "Ruang Lainnya"];
export const DEF_COSTS = ["Pembongkaran", "Pengantaran", "Scaffolding", "Biaya Opsional", "Biaya Lainnya"];

export const LANTAI_CAT = {
  "": { label: "— Pilih material —", mn: 0, mx: 0 },
  keramik_std: { label: "Keramik Standar (30×30 / 40×40)", mn: 195000, mx: 250000 },
  keramik_mozaik: { label: "Keramik Mozaik (Sheet)", mn: 500000, mx: 1500000 },
  keramik_subway: { label: "Keramik Subway / Dekoratif", mn: 400000, mx: 650000 },
  granit_std: { label: "Granit Standar 60×60 Single Loading", mn: 350000, mx: 550000 },
  granit_tile: { label: "Granit Tile 60×60 / 80×80 Double Loading", mn: 600000, mx: 950000 },
  granit_highend: { label: "Granit Motif High-End Slab 120×240", mn: 1950000, mx: 4500000 },
  marmer_lokal: { label: "Marmer Lokal (Ujung Pandang dll)", mn: 1800000, mx: 2100000 },
  marmer_import: { label: "Marmer Import Italy/Turkey (Carrara/Statuary)", mn: 2950000, mx: 9500000 },
  granit_alam: { label: "Granit Alam Slab (Top Table)", mn: 2000000, mx: 4500000 },
  marmer_grade_a: { label: "Marmer Grade A Exotic / Rare Pattern", mn: 7900000, mx: 50000000 },
  solid_std: { label: "Solid Surface Standar (Lokal)", mn: 1750000, mx: 2500000 },
  solid_prem: { label: "Solid Surface Premium Samsung/LG", mn: 3200000, mx: 5800000 },
  quartz: { label: "Quartz Stone Premium", mn: 4000000, mx: 9000000 },
  lantai_manual: { label: "Material Lainnya (harga manual)", mn: 0, mx: 0 },
};

export const bCls = { std: "k-std", dlx: "k-dlx", lux: "k-lux", oth: "k-oth" };
export const bColors = {
  std: { text: "#4ADE80", bg: "rgba(74,222,128,.12)" },
  dlx: { text: "#38BDF8", bg: "rgba(56,189,248,.12)" },
  lux: { text: "#FBBF24", bg: "rgba(251,191,36,.12)" },
  oth: { text: "#A78BFA", bg: "rgba(167,139,250,.12)" },
};

// Mekanisme 2 (per-ruangan/manual) — a fixed 3-tier price-per-satuan range instead of
// Mekanisme 1's per-category catalog, since Mekanisme 2's items are freely-typed area
// descriptions (e.g. "Area Lantai 1 Voyer") rather than picked from a fixed list of work
// types. Same calculation mechanism as Mekanisme 1 (volume × tier price range) — only the
// price source differs, so calcItem() below branches on `it.mode` rather than duplicating
// the room/lantai/cost aggregation logic.
export const MEK2_TIERS = [
  { k: "ESSENTIAL", mn: 5000000, mx: 7000000, b: "std" },
  { k: "SIGNATURE", mn: 9000000, mx: 13000000, b: "dlx" },
  { k: "PRESTIGE", mn: 15000000, mx: 19000000, b: "lux" },
];

// Overwrites the catalog objects IN PLACE (keeps the same object reference so every module
// that already imported CAT/LANTAI_CAT/MEK2_TIERS at load time sees the update automatically
// — no need to thread a "current catalog" prop through every component). Called once the
// admin-managed catalog loads from the backend (see useKalkulatorCatalog); until then every
// consumer keeps working off these hardcoded defaults, so the calculator is never blocked
// on a network round-trip.
export function applyCatalogOverride(data) {
  if (!data) return;
  if (data.categories) { Object.keys(CAT).forEach((k) => delete CAT[k]); Object.assign(CAT, data.categories); }
  if (data.lantai) { Object.keys(LANTAI_CAT).forEach((k) => delete LANTAI_CAT[k]); Object.assign(LANTAI_CAT, data.lantai); }
  if (Array.isArray(data.tiers2) && data.tiers2.length) { MEK2_TIERS.length = 0; MEK2_TIERS.push(...data.tiers2); }
  if (Array.isArray(data.groups) && data.groups.length) { CAT_GROUPS.length = 0; CAT_GROUPS.push(...data.groups); }
}
// Snapshot of the hardcoded defaults (before any backend override is applied), used by the
// admin master-data editor as the reset/seed baseline and by the settings PUT payload shape.
export function catalogSnapshot() {
  return { categories: CAT, lantai: LANTAI_CAT, tiers2: MEK2_TIERS, groups: CAT_GROUPS };
}

let _seq = 1;
export const nextId = () => _seq++;
// mode 1 = Mekanisme 1 (katalog per-item, kelas per kategori). mode 2 = Mekanisme 2
// (uraian diketik manual, kelas = 3 tier universal ESSENTIAL/SIGNATURE/PRESTIGE di atas).
export const mkItem = (mode = 1) => ({ id: nextId(), mode, cat: "", name: "", sat: "m²", p: "", tl: "", qty: 1, ki: -1, hm: "" });
export const mkRoom = (name = "", mode = 1) => ({ id: nextId(), name, items: [mkItem(mode), mkItem(mode)] });
export const mkLantai = (mat = "", desc = "", sat = "m²") => ({ id: nextId(), mat, desc, sat, p: "", l: "", qty: 1, hm: "" });
export const mkCost = (name = "") => ({ id: nextId(), name, sat: "m²", qty: "", price: "" });

const n = (v) => parseFloat(v) || 0;

export function calcVol(it) {
  const p = n(it.p), tl = n(it.tl), qty = n(it.qty) || 1;
  if (it.sat === "m²") return p * tl;
  if (it.sat === "m'") return p + tl;
  if (it.sat === "Unit") return qty;
  return 1;
}
export function calcItem(it) {
  const vol = calcVol(it);
  let mn = 0, mx = 0;
  if (it.mode === 2) {
    const tier = MEK2_TIERS[it.ki];
    if (tier) { mn = tier.mn; mx = tier.mx; }
  } else if (it.cat === "manual") {
    // Legacy path — "manual" is no longer selectable from the Mekanisme 1 dropdown, but a
    // document saved before that change may still carry an item with this cat value, and it
    // must keep computing from its saved hm price when reopened.
    mn = mx = n(it.hm);
  } else {
    const cat = CAT[it.cat];
    // No category picked yet, or kelas not picked yet (it.ki < 0) → price is 0, full stop.
    // Previously this fell back to reading it.hm whenever no category was selected at all,
    // which let a blank-uraian row silently contribute a manual price to the total — the
    // exact "harga manual di Mekanisme 1" loophole the catalog-only redesign was meant to
    // close, just reachable without ever choosing "Pekerjaan Lainnya (manual)".
    if (cat && cat.g && it.ki >= 0 && cat.g[it.ki]) { const g = cat.g[it.ki]; mn = g.mn; mx = g.mx; }
  }
  return { vol, mn: vol * mn, mx: vol * mx, mid: vol * (mn + mx) / 2 };
}
export function roomTot(room) {
  return room.items.reduce((a, it) => { const c = calcItem(it); return { mn: a.mn + c.mn, mx: a.mx + c.mx, mid: a.mid + c.mid }; }, { mn: 0, mx: 0, mid: 0 });
}
export function costVal(c) { return n(c.qty) * n(c.price); }

export function calcLantaiVol(lt) {
  const p = n(lt.p), l = n(lt.l), qty = n(lt.qty) || 1;
  if (lt.sat === "m²") return p * l;
  if (lt.sat === "m'") return p;
  if (lt.sat === "Unit") return qty;
  return 1;
}
export function calcLantai(lt) {
  const vol = calcLantaiVol(lt);
  const mat = LANTAI_CAT[lt.mat];
  let mn = 0, mx = 0;
  if (!mat || lt.mat === "" || lt.mat === "lantai_manual") { mn = mx = n(lt.hm); }
  else { mn = mat.mn; mx = mat.mx; }
  return { vol, mn: vol * mn, mx: vol * mx, mid: vol * (mn + mx) / 2 };
}
export function lantaiTot(lantais) {
  return lantais.reduce((a, lt) => { const c = calcLantai(lt); return { mn: a.mn + c.mn, mx: a.mx + c.mx, mid: a.mid + c.mid }; }, { mn: 0, mx: 0, mid: 0 });
}

// Grand totals across rooms + lantai + costs, plus discount applied proportionally to
// min/max too (not just the mid estimate) — the source calculator only discounted the mid
// total, which could make "Total Setelah Diskon" print BELOW the "Minimal (Std)" figure
// shown right above it once a large discount was entered. Applying the same % (or the same
// flat cut, floored per band) to all three keeps the range internally consistent.
export function grandTotals(rooms, lantais, costs, discount) {
  let gmn = 0, gmx = 0, gmid = 0;
  rooms.forEach((r) => { const t = roomTot(r); gmn += t.mn; gmx += t.mx; gmid += t.mid; });
  const lt = lantaiTot(lantais);
  gmn += lt.mn; gmx += lt.mx; gmid += lt.mid;
  const ct = costs.reduce((a, c) => a + costVal(c), 0);
  gmn += ct; gmx += ct; gmid += ct;

  const discType = discount?.type || "none";
  const discVal = n(discount?.value);
  let discMid = 0, discMn = 0, discMx = 0;
  if (discType === "percent" && discVal > 0) {
    discMid = (gmid * discVal) / 100; discMn = (gmn * discVal) / 100; discMx = (gmx * discVal) / 100;
  } else if (discType === "nominal" && discVal > 0) {
    discMid = discVal; discMn = Math.min(gmn, discVal); discMx = Math.min(gmx, discVal);
  }
  return {
    min: gmn, max: gmx, mid: gmid,
    discount_amount: discMid,
    final: Math.max(0, gmid - discMid),
    final_min: Math.max(0, gmn - discMn),
    final_max: Math.max(0, gmx - discMx),
  };
}

// --- Mekanisme 1 "Opsi 2" — semua kelas sekaligus, dari input Opsi 1 yang sama -----------
// Opsi 1 (di atas) tetap apa adanya: satu item = satu kelas terpilih (`it.ki`) = satu harga.
// Opsi 2 TIDAK mengubah cara Opsi 1 bekerja — ia membaca ULANG persis rooms/lantai/biaya yang
// sama, tapi mengabaikan `it.ki` dan menghitung item itu di SEMUA kelas yang tersedia di
// kategorinya sekaligus, lalu menjumlahkan per label kelas ke seluruh dokumen. Hasilnya bukan
// satu angka tapi beberapa "paket" (ESSENTIAL/SIGNATURE/Luxury/Std Duco/dst — apa adanya,
// sesuai kelas yang benar-benar dimiliki item-item yang dipakai). Dipakai untuk membuat
// dokumen kedua yang terpisah dari dokumen Opsi 1 aslinya (lihat KalkulatorBuilder.jsx).
//
// Item yang tidak punya banyak kelas untuk dipecah (Mekanisme 2, "manual", atau belum pilih
// kategori) tetap disertakan tapi sebagai biaya flat — nilainya sama di setiap paket, persis
// seperti Lantai/Biaya Tambahan yang memang tidak dari kelas.
export function calcItemAllClasses(it) {
  if (it.mode === 2 || it.cat === "manual" || !it.cat) return null;
  const cat = CAT[it.cat];
  if (!cat || !cat.g || !cat.g.length) return null;
  const vol = calcVol(it);
  return cat.g.map((g) => ({ k: g.k, b: g.b, mn: vol * g.mn, mx: vol * g.mx, mid: vol * (g.mn + g.mx) / 2 }));
}

export function documentClassBreakdown(rooms, lantais, costs, discount) {
  const buckets = new Map(); // label kelas -> {k,b,mn,mx,mid}
  let flat = { mn: 0, mx: 0, mid: 0 };

  rooms.forEach((room) => {
    room.items.forEach((it) => {
      const all = calcItemAllClasses(it);
      if (all) {
        all.forEach((g) => {
          const cur = buckets.get(g.k) || { k: g.k, b: g.b, mn: 0, mx: 0, mid: 0 };
          cur.mn += g.mn; cur.mx += g.mx; cur.mid += g.mid;
          buckets.set(g.k, cur);
        });
      } else {
        const c = calcItem(it);
        flat = { mn: flat.mn + c.mn, mx: flat.mx + c.mx, mid: flat.mid + c.mid };
      }
    });
  });
  const lt = lantaiTot(lantais);
  flat = { mn: flat.mn + lt.mn, mx: flat.mx + lt.mx, mid: flat.mid + lt.mid };
  const ct = costs.reduce((a, c) => a + costVal(c), 0);
  flat = { mn: flat.mn + ct, mx: flat.mx + ct, mid: flat.mid + ct };

  const discType = discount?.type || "none";
  const discVal = n(discount?.value);
  const packages = Array.from(buckets.values()).map((bkt) => {
    const mn = bkt.mn + flat.mn, mx = bkt.mx + flat.mx, mid = bkt.mid + flat.mid;
    let discAmt = 0;
    if (discType === "percent" && discVal > 0) discAmt = (mid * discVal) / 100;
    else if (discType === "nominal" && discVal > 0) discAmt = Math.min(mid, discVal);
    return { k: bkt.k, b: bkt.b, mn, mx, mid, discount_amount: discAmt, final: Math.max(0, mid - discAmt) };
  }).sort((a, b) => a.mid - b.mid);

  return { opsi: 2, packages, flat };
}

// Formatted plain-text summary for the "Salin ke WhatsApp" quick-share button — ported
// from the source calculator's copyWA(), same layout/wording, just fed from React state
// instead of the DOM. This is separate from the "Kirim ke Client" doc-row button (which
// sends a link to the saved, printable document) — this one lets a sales/admin paste a
// quick text estimate into a chat before the calculator is even saved.
export function buildWaText(client, rooms, lantais, costs, discount, totals) {
  const nama = client?.nama || "-", hp = client?.telp || "-", alamat = client?.alamat || "-";
  const tgl = new Date().toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" });
  let txt = `*ESTIMASI BIAYA - ADARI INTERIOR*\n_Connecting Needs & Wants_\n`;
  txt += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  txt += `Klien : ${nama}\nWA    : ${hp}\nProyek: ${alamat}\nTgl   : ${tgl}\n`;
  txt += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n\n`;

  rooms.forEach((room, ri) => {
    const t = roomTot(room);
    if (t.mid <= 0) return;
    txt += `*${ri + 1}. ${room.name || "Ruangan"}*\n`;
    room.items.forEach((it, ii) => {
      const c = calcItem(it);
      if (c.mid <= 0) return;
      let nm, kls;
      if (it.mode === 2) {
        nm = it.name || "Area";
        kls = it.ki >= 0 && MEK2_TIERS[it.ki] ? ` (${MEK2_TIERS[it.ki].k})` : "";
      } else {
        const cat = CAT[it.cat];
        nm = it.cat === "manual" ? it.name : (cat?.label || "");
        kls = cat?.g && it.ki >= 0 ? ` (${cat.g[it.ki].k})` : "";
      }
      const volStr = it.sat === "m²" ? c.vol.toFixed(2) + "m²" : it.sat === "m'" ? c.vol.toFixed(1) + "m'" : it.sat === "Unit" ? it.qty + " unit" : "LS";
      txt += `   ${ii + 1}. ${nm}${kls} — ${volStr} = ${rupiah(c.mid)}\n`;
    });
    txt += `   *Subtotal: ${rupiah(t.mid)}*\n\n`;
  });

  const ltHas = lantais.some((lt) => calcLantai(lt).mid > 0);
  if (ltHas) {
    txt += `*Lantai, Top Table & Backsplash*\n`;
    lantais.forEach((lt, i) => {
      const c = calcLantai(lt);
      if (c.mid <= 0) return;
      const mat = LANTAI_CAT[lt.mat];
      const nm = mat && lt.mat !== "" && lt.mat !== "lantai_manual" ? mat.label : "Manual";
      const desc = lt.desc ? ` (${lt.desc})` : "";
      const volStr = lt.sat === "m²" ? c.vol.toFixed(2) + "m²" : lt.sat === "m'" ? c.vol.toFixed(2) + "m'" : lt.sat === "Unit" ? (lt.qty || 1) + " unit" : "LS";
      txt += `   ${i + 1}. ${nm}${desc} — ${volStr} = ${rupiah(c.mid)}\n`;
    });
    txt += `   *Subtotal: ${rupiah(lantaiTot(lantais).mid)}*\n\n`;
  }

  const ct = costs.reduce((a, c) => a + costVal(c), 0);
  if (ct > 0) {
    txt += `*Biaya Tambahan*\n`;
    costs.forEach((c, i) => { const t = costVal(c); if (t > 0) txt += `   ${i + 1}. ${c.name} = ${rupiah(t)}\n`; });
    txt += `   *Subtotal: ${rupiah(ct)}*\n\n`;
  }

  txt += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  if ((totals.discount_amount || 0) > 0) {
    txt += `*SUBTOTAL SEBELUM DISKON: ${rupiah(totals.mid)}*\n`;
    const discLabel = discount?.type === "percent" ? `Diskon ${discount.value}%` : "Diskon";
    txt += `${discLabel}: - ${rupiah(totals.discount_amount)}\n`;
    txt += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
    txt += `*TOTAL SETELAH DISKON: ${rupiah(totals.final)}*\n\n`;
  } else {
    txt += `*TOTAL ESTIMASI: ${rupiah(totals.mid)}*\n\n`;
  }

  txt += `_Estimasi awal Price List 2026. Harga final menyesuaikan model, kerumitan & material._\n✦ Free Survey ✦ Free Konsultasi ✦ Free Instalasi\nUntuk project di bawah Rp 100 jt dikenakan biaya ongkir Rp 1.000.000 (Jabodetabek, Palembang & sekitarnya)\nwww.adariinterior.com`;
  return txt;
}

// Opsi 2 variant — same header/client block, but the body is the per-kelas package list
// (documentClassBreakdown's output) instead of a room-by-room item list, since Opsi 2's
// whole point is letting the client compare package totals rather than read line items.
export function buildWaTextOpsi2(client, breakdown) {
  const nama = client?.nama || "-", hp = client?.telp || "-", alamat = client?.alamat || "-";
  const tgl = new Date().toLocaleDateString("id-ID", { day: "2-digit", month: "long", year: "numeric" });
  let txt = `*ESTIMASI BIAYA - ADARI INTERIOR*\n_Connecting Needs & Wants_\n`;
  txt += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  txt += `Klien : ${nama}\nWA    : ${hp}\nProyek: ${alamat}\nTgl   : ${tgl}\n`;
  txt += `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n\n`;
  txt += `*PILIHAN PAKET* (silakan pilih salah satu)\n\n`;
  (breakdown.packages || []).forEach((p, i) => {
    txt += `${i + 1}. *${p.k}* — ${rupiah(p.final)}\n`;
  });
  txt += `\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n`;
  txt += `_Estimasi awal Price List 2026. Harga final menyesuaikan model, kerumitan & material._\n✦ Free Survey ✦ Free Konsultasi ✦ Free Instalasi\nUntuk project di bawah Rp 100 jt dikenakan biaya ongkir Rp 1.000.000 (Jabodetabek, Palembang & sekitarnya)\nwww.adariinterior.com`;
  return txt;
}
